import { ArrowBackOutlined } from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { 
    Accordion as MuiAccordion, 
    AccordionDetails as MuiAccordionDetails, 
    AccordionSummary as MuiAccordionSummary, 
    Box, 
    Typography,
    Theme 
} from '@mui/material';
import { styled } from '@mui/styles';
import * as React from 'react';

export default function Accordion({data}:{data:any[]}) {


  const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(({ theme }: {theme:Theme}) => ({
    border: `1px solid ${theme.palette.divider}`,
    borderRight: "none",
    borderLeft: "none",
    backgroundColor: theme.palette.primary.main,
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&:hover':{
      backgroundColor: theme.palette.primary.dark,
      transition: "0.3s"
    }
  }));

  const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
      expandIcon={<ArrowBackOutlined sx={{ fontSize: '0.9rem' }} />}
      {...props}
    />
    //@ts-ignore
  ))(({ theme }:{theme:Theme}) => ({
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, .05)'
        : 'rgba(0, 0, 0, .03)',
    flexDirection: 'reverse',
    '& .MuiAccordionSummary-expandIconWrapper': {
      transform: 'rotate(-90deg)',
    },
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
      transform: 'rotate(0deg)',
    },
  }));

  const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: 0,
    borderTop: '1px solid rgba(0, 0, 0, .125)',
    margin: 0
  }));

  return (
    <>
      
      {
          data.map((obj, index)=>(

            <Accordion
                sx={style.accordion}
                key={index}
                
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={style.accordionSummary} />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Box sx={{marginRight: "6px"}} >{obj.Icon}</Box>
                    <Typography sx={style.typography}>{obj.title}</Typography>
                </AccordionSummary>
                <AccordionDetails
                    sx={style.accordionDetails}
                >
                   {obj.content}
                </AccordionDetails>
            </Accordion>

          ))
      }

      {/* <MUIAccordion disabled>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3a-content"
          id="panel3a-header"
        >
          <Typography>Disabled Accordion</Typography>
        </AccordionSummary>
      </MUIAccordion> */}
    </>
  );
}

const style={

    accordion:{
        boxShadow: "none",
        backgroundColor: "green",
    },
    accordionDetails:{
        boxShadow: "none",
    },
    typography:{
        color: "grey.200",
        fontSize: 14
    },
    accordionSummary:{
        color: "grey.200",
        fontSize: 14,
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        padding: 0,
    }

}